<!-- 第三步：确认订单 -->
<template>
  <div class="confirm">
    <div class="info-title">
      <i class="selftmreg_shuxian"></i>
      <h4>
        商标信息
        <span class="edit" @click="goStepOne">
          <i class="el-icon-edit"></i>
          <b>编辑</b>
        </span>
      </h4>
    </div>
    <!-- 商标信息 -->
    <div class="brand-info">
      <p>
        <strong>商标类型：</strong>
        <span>
          {{
          this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_type == 1
          ? "文字"
          : this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_type ==
          2
          ? "图形"
          : "文字及图形"
          }}
        </span>
      </p>
      <p
        v-if="
          this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_type !== 2
        "
      >
        <strong>商标名称：</strong>
        <span>
          {{
          this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_name
          }}
        </span>
      </p>
      <p>
        <strong>商标图样：</strong>

        <img :src="brandIcon" alt />
      </p>
      <p>
        <strong>商标类别：</strong>
        <span class="detail-type" v-for="(item,index) in this.$parent.$parent.confirmStepsParams.stepOneThreeParams.nclones" :key="index">
          <i>
            {{
            item.code + item.name
            }}
          </i>
          <br />
          <b
            v-for="(n,i) in item.nclThree"
            :key="i"
          >{{ n.code + " " + n.name }}</b>
          <!--之前的:key与{{}} item.fullname -->
        </span>
      </p>
    </div>

    <div class="info-title">
      <i class="selftmreg_shuxian"></i>
      <h4>
        申请人及联系人信息
        <span class="edit" @click="goStepTwo">
          <i class="el-icon-edit"></i>
          <b>编辑</b>
        </span>
      </h4>
    </div>
    <!-- 申请人及联系人信息 -->
    <div class="user-info">
      <ul>
        <li>
          <strong>申请人类型：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
            ? "企业"
            : "个体户"
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
          "
        >
          <strong>公司名称：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams
            .companyName
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
          "
        >
          <strong>邮政编码：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.postalCode
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
          "
        >
          <strong>公司地址：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams
            .licenseAddress
            }}
          </span>
        </li>

        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
          "
        >
          <strong>申请人姓名：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.username
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
          "
        >
          <strong>邮政编码：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams
            .upostalCode
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
          "
        >
          <strong>申请人地址：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.idAddress
            }}
          </span>
        </li>

        <li>
          <strong>联系人：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.customer
            }}
          </span>
        </li>
        <li>
          <strong>联系电话：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.telNum
            }}
          </span>
        </li>
        <li>
          <strong>电子邮箱：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.email
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
          "
        >
          <strong>信用编码：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.creditCode
            }}
          </span>
        </li>
        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
          "
        >
          <strong>信用编码：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams
            .ucreditCode
            }}
          </span>
        </li>

        <li
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
          "
        >
          <strong>身份证号：</strong>
          <span>
            {{
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.idCard
            }}
          </span>
        </li>
      </ul>
    </div>

    <!-- 材料信息 -->
    <div>
      <div class="info-title">
        <i class="selftmreg_shuxian"></i>
        <h4>
          材料信息&nbsp;&nbsp;&nbsp;
          <!-- <strong>(可跳过进行下一步，支付完成后，在订单中上传即可)</strong> -->
        </h4>
      </div>
      <div class="show-imgs">
        <ul
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
          "
        >
          <li
            v-for="(item, index) in this.$parent.$parent.confirmStepsParams
              .stepTwoNineParams.company"
            :key="index"
            v-show="item.Icon != ''&&!item.Icon.endsWith('pdf')"
          >
            <img :src="item.Icon" alt />
            <span>{{ item.Text }}</span>
          </li>
        </ul>
        <ul
          v-if="
            this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
          "
        >
          <li
            v-for="(obj, index) in this.$parent.$parent.confirmStepsParams
              .stepTwoNineParams.user"
            :key="index + obj.Text"
            v-show="obj.Icon != ''&&!obj.Icon.endsWith('pdf')"
          >
            <img :src="obj.Icon" alt />
            <span>{{ obj.Text }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="info-title">
      <i class="selftmreg_shuxian"></i>
      <h4>订单备注</h4>
    </div>
    <!-- 文本域 -->
    <el-input type="textarea" :rows="2" placeholder="如有特殊需要，请填写订单备注" v-model="textarea"></el-input>
  </div>
</template>

<script>
import { addOrder,getParamsFor360  } from "@/api/brand360.js";
export default {
  data() {
    return {
      textarea: "",

      // 商标展示
      brandIcon: "",
      smallSum:""
    };
  },
  methods: {
    // 子向父传参 this.$emit(eventName,params)
    // 编辑 商标信息
    goStepOne() {
      // 去第一步骤的页面
      this.$emit("geteditindex", 0);
    },
    // 编辑 申请人及联系人信息
    goStepTwo() {
      // 去第二步骤的页面
      this.$emit("geteditindex", 1);
    },
        //创建订单
    addOrderUser() {
      //商标类型
      let brandType = "";
      if (this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_type == 1) {
        brandType = "3";
      } else if (this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_type == 2) {
        brandType = "4";
      } else {
        brandType = "5";
      }
      //商标小类
      // let nclones = [
      //   {
      //     code:this.$store.state.brand360.codeid,
      //     name:this.$store.state.brand360.typeName,
      //     nclThree:this.$parent.$parent.confirmStepsParams.stepOneThreeParams.smallKinds
      //   }
      // ]
      // console.log(this.$parent.$parent.confirmStepsParams.stepOneThreeParams.nclones,"nclones")
      let arrNclones = this.$parent.$parent.confirmStepsParams.stepOneThreeParams.nclones;
      let smallNum = [];
      for (let index = 0; index < arrNclones.length; index++) {
        if(arrNclones[index].nclThree.length>10){
          smallNum.push(arrNclones[index].nclThree.length-10)
        }
      }
      if(smallNum.length>=1){
        this.smallSum =smallNum.reduce((acc,item)=>{
        return acc+item
      })
      }
      let obj = {
        channelItemCode: "zzsbzc", // Y 产品的渠道编码
        channelItemAppendName: this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_name,//商标名称
        payCode: "zzsbzc-1", // Y 支付价格code // Y 支付价格code
        quantity: this.$parent.$parent.confirmStepsParams.stepOneThreeParams.nclones.length, // Y 购买数量
        ////////////////////
        additions: {
          // N 附加购买项目
          payCode: "zzsbzc-2", // Y 支付价格code
          quantity: this.smallSum||"" // Y 购买数量
        },
        //////////
        totalSum: this.$parent.$parent.amount, // Y 订单总金额---(商标自助注册计算格式：小于10项为产品价格×10，大于10项的为产品价格×小项数量)
        payTotalSum: this.$parent.$parent.amount, // Y 订单付款总金额
        notes: this.textarea, // N 订单备注
        //订单联系人信息
        orderContact: {
          // N 订单联系人信息，没有则填写{}
          contacts: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.customer, // N 联系人
          mobile: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.telNum, // N 联系人电话
          email: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.email, // N 联系人邮箱
          fax: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.faxNumber //传真
        },
        channelOrder: {
          // channelServiceNo: "", // N 服务单号（即渠道服务单号）
          // channelOrderNo: "", // N 服务订单号（即渠道服务订单号，格式为： XX1,XX2）
          // needNo: "", // N 需求单号（即渠道需求单号）
          // payTime: "", // N 渠道需求单号支付时间
          // orderStatus: 1, // N 渠道需求单号支付支付状态 1: 待付款, 2: 已付款
          // channelParams: "" // N 渠道参数（自定义参数）
        }, // Y 渠道订单信息，没有则填写{}
        deliveryData: {
          apply: {
            //申请信息
            applyAddr:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.licenseAddress, //执照详细地址
            applyArea: "", //申请区域--暂时没有用到
            businessLicensePic: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1?this.$parent.$parent.confirmStepsParams.stepTwoNineParams.company[0].Icon:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.user[0].Icon, //营业执照jpg地址
            businessLicensePdf:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1?this.$parent.$parent.confirmStepsParams.stepTwoNineParams.company[3].Icon:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.user[4].Icon, //营业执照pdf地址
            code:
              this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1
                ? this.$parent.$parent.confirmStepsParams.stepTwoNineParams.creditCode
                :  this.$parent.$parent.confirmStepsParams.stepTwoNineParams
            .ucreditCode, //统一社会信用代码
            customerType: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1 ? "ent" : "person", //申请人类型 person个人，ent企业
            identityCardNo: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2? this.$parent.$parent.confirmStepsParams.stepTwoNineParams.idCard : "", //申请人身份证号--（申请类型为个人有此值）
            identityCardPic: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1?"":this.$parent.$parent.confirmStepsParams.stepTwoNineParams.user[1].Icon, //申请人身份证jpg地址--（申请类型为个人有此值）
            identityCardPdf: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1?"":this.$parent.$parent.confirmStepsParams.stepTwoNineParams.user[5].Icon, //申请人身份证pdf地址  --（申请类型为个人有此值）
            name:
              this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 2
                ? this.$parent.$parent.confirmStepsParams.stepTwoNineParams.username
                : "", //申请人名称
            gzwtsUrl: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1?this.$parent.$parent.confirmStepsParams.stepTwoNineParams.company[1].Icon:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.user[2].Icon, //盖章委托书url
            smwjUrl: this.$parent.$parent.confirmStepsParams.stepTwoNineParams.atype == 1?this.$parent.$parent.confirmStepsParams.stepTwoNineParams.company[2].Icon:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.user[3].Icon, //说明文件url
            zipCode:this.$parent.$parent.confirmStepsParams.stepTwoNineParams.postalCode
               //邮政编码
          },
          tm: {
            colorizedPicUrl: this.brandIcon, //商标彩色图样
            tmName: this.$parent.$parent.confirmStepsParams.stepOneThreeParams.tm_name, //商标名称
            picUrl: this.brandIcon, //商标图样
            tmFormType: brandType //商标类型形式：1: 立体, 3: 字, 4: 图, 5: 字图, 6: 颜色, 7: 彩色
          },
          nclones: this.$parent.$parent.confirmStepsParams.stepOneThreeParams.nclones
        } //Y 交付单信息，没有则填写{}
      };
      // console.log(obj,"obj")
      addOrder(obj).then(res => {
        if(res.status == 0){
          // console.log("创建订单--",res)
          //获取订单号
          let orderId = res.data.orderNo
          getParamsFor360(orderId).then((res)=>{
            if(res.status == 0){
              // console.log("获取参数360--",res.data)
              //链接跳转到360订单结算页
              window.open(`https://e.360.cn/static/zhihui/paymentProcedure/settlement/?sku_id=${res.data.sku_id}&amount=${res.data.amount}&consignee=${res.data.consignee}&email=${res.data.email}&mobile=${res.data.mobile}&order_id=${res.data.order_id}&price=${res.data.price}&quantity=${res.data.quantity}&sign=${res.data.sign}`,"_self")
            }else{
              this.$message.error('订单创建失败，请稍后重试。');
            }
          })
        }else{
          this.$message.error('订单创建失败，请稍后重试。');
        }
      }).catch((err)=>{
        console.log(err)
      });
    },
  },
  created() {
    // 获取缓存里面的商标图片地址
    let brandIcon = localStorage.getItem("icon");
    this.brandIcon = brandIcon;
    // // 确认订单编号的请求--- 暂时是 500
    // submitSelfregTmOrder().then(res => {
    //   console.log(res);
    // });

    // this.addOrderUser()
  }
};
</script>

<style lang="scss" scoped>
.info-title {
  .selftmreg_shuxian {
    width: 3px;
    height: 15px;
    background-color:#00AB39;
    display: inherit;
    float: left;
    margin-top: 4px;
    margin-right: 10px;
  }
  h4 {
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(83, 83, 83, 1);
    margin-bottom: 15px;
    strong {
      margin-left: 35px;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(99, 101, 105, 1);
    }
  }
}
// 编辑图文
.edit {
  color: #00AB39;
  cursor: pointer;
}

// 商标信息
.brand-info {
  p {
    margin-bottom: 23px;
    strong {
      width: 120px;
      display: inline-block;
      text-align: right;
      color: rgb(99, 101, 105);
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
    span.detail-type {
      display: inline-block;
      width: 900px;
      vertical-align: top;
      margin-top: 10px;
      margin-left: 120px;
      i {
        font-size: 14px;
        font-weight: 600;
        display: inline-block;
        padding-bottom: 10px;
      }
      b {
        font-size: 14px;
        font-weight: 400;
        margin-right: 20px;
        text-align: left;
        color: #333;
      }
    }
    &>:nth-of-type(1){
      margin-left: 0 !important;
      margin-top: 0 !important;
    }
    img {
      display: inline-block;
      width: 140px;
      height: 140px;
      border: 2px dashed rgb(233, 233, 233);
      vertical-align: top;
    }
  }
}

// 申请人及联系人信息
.user-info {
  ul {
    li {
      display: inline-block;
      width: 50%;
      padding-bottom: 23px;
      strong {
        width: 120px;
        display: inline-block;
        text-align: right;
        color: rgb(99, 101, 105);
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #333;
      }
    }
  }
}

// 材料信息
.show-imgs {
  padding-left: 44px;
  ul {
    display: flex;
    li {
      display: inline-block;
      margin-left: 15px;
      width: 100px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        height: 118px;
        width: 98px;
        border: 2px dashed rgb(233, 233, 233);
      }
      span {
        color: #636569;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
// 订单备注  样式没加上！！
.confirm div.el-textarea textarea.el-textarea__inner {
  border-radius: 0;
  min-width: 980px;
  height: 82px;
  resize: none;
  border: 1px solid #d6daeb;
}
</style>
